import {ArticleDetails} from "../interfaces/response/ArticleDetails";
import {
    AsciugatricePosizionamento, AsciugatriceTipologia, CantinettaPosizionamento,
    CappeTipologia, CondizionatoreTipologia,
    CongelatorePosizionamento,
    CongelatoreTipologia, CucinaTipologiaPianoCottura,
    FornoPosizionamento,
    FornoTipologia, FrigoriferoNumeroStelle,
    FrigoriferoPosizionamento,
    FrigoriferoTipologia, LavasciugaTipologia,
    LavastovigliePosizionamento,
    LavatricePosizionamento,
    LavatriceTipologia,
    LavelloTipologia,
    MicroondePosizionamento,
    PianoCotturaMateriale,
    PianoCotturaPosizionamento,
    PianoCotturaTipologia, SiNo
} from "../components/inserimentoDati/Constants";


export const brands = [
    "Aeg",
    "Akai",
    "Asko",
    "Beko",
    "Bertazzoni La Germania",
    "Bosch",
    "Cadel",
    "Candy",
    "Comfee",
    "Daya",
    "De Longhi",
    "Electrolux",
    "Fisher & Paykel",
    "Faber",
    "Foster",
    "Franke",
    "Gorenje",
    "Glem",
    "Grundig",
    "Haier",
    "Hisense",
    "Hoover",
    "Hotpoint Ariston",
    "Indesit",
    "Kenwood",
    "Kitchenaid",
    "Liebherr",
    "LG",
    "Metro",
    "Mitsubishi",
    "Midea",
    "Miele",
    "Neff",
    "Ocean",
    "R.G.V.",
    "Rosieres",
    "Samsung",
    "Sangiorgio",
    "Severin",
    "Sharp",
    "Schaub Lorenz",
    "Siemens",
    "Smeg",
    "Telefunken",
    "Whirlpool",
    "Zerowatt"
]

export const colors = [
    "Bianco",
    "Argento",
    "Acciaio inox",
    "Nero",
    "Antracite",
    "Nero, Acciaio Inox",
    "Grigio, Bianco",
    "Rosso",
    "Rosa",
    "Beige",
    "Sabbia",
    "Lime"
]

export const energyClass = [
    "A++ -40%",
    "A++ -50%",
    "A++ -60%",
    "A+++",
    "A+++ -10%",
    "A+++ -20%",
    "A+++ -30%",
    "A+++ -40%",
    "A+++ -50%",
    "A+++ -60%",
    "A+ -20%",
    "A+ -10%",
    "A+ -30%",
    "A+ -40%",
    "A+ -50%",
    "A+ -60%",
    "A+",
    "A++",
    "A++ -10%",
    "A++ -20%",
    "A++ -30%",
    "-",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "A",
    "A -20%",
    "A -10%",
    "A -30%",
    "A -40%",
    "A -50%",
    "A -60%"
];

export const energyScale: string[] = [
    "A+++ to D",
    "A++ to E",
    "A+ to F",
    "A to G"
]

interface SingleArticleMapping {
    name: string,
    color: string
}

interface ArticleMapping {
    [code: string]: SingleArticleMapping
}

export const ArticleMappings: ArticleMapping = {
    'AELETTR': {
        name: 'Altri Elettrodomestici',
        color: 'teal'
    },
    'ASCIUGATRICI': {
        name: 'Asciugatrice',
        color: 'red'
    },
    'CANTINETTE': {
        name: 'Cantinette Vino',
        color: 'pink'
    },
    'CAPPE': {
        name: 'Cappe',
        color: 'grape'
    },
    'CONDIZIONAT': {
        name: 'Condizionatori / Deumidificatori',
        color: 'violet'
    },
    'CONGELATORE': {
        name: 'Congelatori',
        color: 'indigo'
    },
    'CUCINA': {
        name: 'Cucina',
        color: 'blue'
    },
    'FORNI': {
        name: 'Forni',
        color: 'cyan'
    },
    'FRIGORIFERI': {
        name: 'Frigoriferi',
        color: 'green'
    },
    'LAVASCIUGA': {
        name: 'Lavasciuga',
        color: 'lime'
    },
    'LAVASTOVIGLIE': {
        name: 'Lavastoviglie',
        color: 'yellow'
    },
    'LAVATRICI': {
        name: 'Lavatrici',
        color: 'orange'
    },
    'LAVELLI': {
        name: 'Lavelli',
        color: 'teal'
    },
    'MICROONDE': {
        name: 'Microonde',
        color: 'red'
    },
    'MISCELATORI': {
        name: 'Miscelatori',
        color: 'pink'
    },
    'PCOTTGAS': {
        name: 'Piani Cottura a Gas',
        color: 'grape'
    },
    'PCOTTIND': {
        name: 'Piani Cottura a Induzione',
        color: 'violet'
    },
    'PICELETTR': {
        name: 'Piccoli Elettrodomestici',
        color: 'indigo'
    },
    'TELEVISORI': {
        name: 'Televisori',
        color: 'blue'
    },
    'MATELETTRICO': {
        name: 'Materiale Elettrico',
        color: 'dark'
    },
    'DEFAULT': {
        name: 'Categoria non Disponibile',
        color: 'gray'
    }
}

export const getCategoryStringFromCode = (categoryCode: string): string => {
    let mapping = ArticleMappings[categoryCode.substring(0, categoryCode.length - 3)]
    if (!mapping) {
        mapping = ArticleMappings['DEFAULT']
    }
    return mapping.name;
}


/*
Object: {
Label: {
    Source,
    Included Categories. Default All,
    Options,
    Checkbox
}
 */

interface ArticleAttribute {
    source: string
    categories?: string[]
    options?: string[]
    checkbox?: boolean
    default?: string
    label?: string
    formLabel?: string
    transform?: (input: string) => string
}

const specificCategoryArticleAttributes: { [attribute: string]: ArticleAttribute } =
    {
        "Tipologia Lavatrice": {
            source: "generalArticleDetails.washingMachineType",
            categories: ["LAVATRICI001", "LAVATRICI002"],
            options: LavatriceTipologia
        },
        // LAVATRICE
        "Posizionamento Lavatrice": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["LAVATRICI001", "LAVATRICI002"],
            options: LavatricePosizionamento
        },
        "Programmi di lavaggio": {
            label: "Programmi di Lavaggio",
            formLabel: "Lavatrice - Programmi di Lavaggio",
            source: "generalArticleDetails.washingMachinePrograms",
            categories: ["LAVATRICI001", "LAVATRICI002", "LAVASCIUGA001", "LAVASCIUGA002"],
        },
        // ASICUGATRICE
        "Posizionamento Asciugatrice": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["ASCIUGATRICI001", "ASCIUGATRICI002"],
            options: AsciugatricePosizionamento
        },
        "Tipologia Asciugatrice": {
            source: "generalArticleDetails.dryerType",
            categories: ["ASCIUGATRICI001", "ASCIUGATRICI002"],
            options: AsciugatriceTipologia
        },
        // LAVASCIUGA
        "Posizionamento Lavasciuga": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["LAVASCIUGA001", "LAVASCIUGA002"],
            options: AsciugatricePosizionamento
        },
        "Tipologia Lavasciuga": {
            source: "generalArticleDetails.washerDryerType",
            categories: ["LAVASCIUGA001", "LAVASCIUGA002"],
            options: LavasciugaTipologia
        },
        "Capacità di Carico Asciugatura": {
            label: "Capacità di Carico Asciugatura (Kg)",
            formLabel: "Capacità di Carico Asciugatura",
            source: "generalArticleDetails.dryingLoadCapacity",
            categories: ["LAVASCIUGA001", "LAVASCIUGA002"]
        },
        "Capacità di Carico Lavaggio": {
            label: "Capacità di Carico Lavaggio (Kg)",
            formLabel: "Capacità di Carico Lavaggio",
            source: "generalArticleDetails.washingLoadCapacity",
            categories: ["LAVASCIUGA001", "LAVASCIUGA002", "LAVATRICI001", "LAVATRICI002"]
        },
        // LAVASTOVIGLIE
        "Posizionamento Lavastoviglie": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["LAVASTOVIGLIE001", "LAVASTOVIGLIE002"],
            options: LavastovigliePosizionamento
        },
        "Numero di Coperti": {
            source: "generalArticleDetails.coverNumber",
            categories: ["LAVASTOVIGLIE001", "LAVASTOVIGLIE002"],
        },
        // CONGELATORI
        "Posizionamento Congelatore": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["CONGELATORE001", "CONGELATORE002"],
            options: CongelatorePosizionamento
        },
        "Tipologia Congelatore": {
            source: "generalArticleDetails.freezerType",
            categories: ["CONGELATORE001", "CONGELATORE002"],
            options: CongelatoreTipologia
        },
        // FRIGORIFERI
        "Posizionamento Frigorifero": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["FRIGORIFERI001", "FRIGORIFERI002"],
            options: FrigoriferoPosizionamento
        },
        "Tipologia Frigorifero": {
            source: "generalArticleDetails.fridgeType",
            categories: ["FRIGORIFERI001", "FRIGORIFERI002"],
            options: FrigoriferoTipologia
        },
        "Numero Stelle Frigorifero": {
            label: "Numero di Stelle (americano)",
            formLabel: "Numero Stelle Frigorifero",
            source: "generalArticleDetails.fridgeNumberOfStars",
            categories: ["FRIGORIFERI001", "FRIGORIFERI002"],
            options: FrigoriferoNumeroStelle
        },
        // CANTINETTE VINO
        "Numero di bottiglie": {
            label: "Numero di bottiglie",
            source: "generalArticleDetails.wineFridgeNumberOfBottles",
            categories: ["CANTINETTE001", "CANTINETTE002"]
        },
        "Posizionamento Cantinetta Vino": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["CANTINETTE001", "CANTINETTE002"],
            options: CantinettaPosizionamento
        },
        // FORNI
        "Posizionamento Forno": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["FORNI001", "FORNI002"],
            options: FornoPosizionamento
        },
        "Tipologia Forno": {
            source: "generalArticleDetails.ovenType",
            categories: ["FORNI001", "FORNI002"],
            options: FornoTipologia
        },
        // PIANO COTTURA
        "Posizionamento Piano Cottura": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["PCOTTIND001", "PCOTTIND002", "PCOTTGAS001", "PICOTTGAS002"],
            options: PianoCotturaPosizionamento
        },
        "Tipologia Piano Cottura": {
            source: "generalArticleDetails.stoveType",
            categories: ["PCOTTIND001", "PCOTTIND002", "PCOTTGAS001", "PICOTTGAS002"],
            options: PianoCotturaTipologia
        },
        "Materiale Piano Cottura": {
            source: "generalArticleDetails.stoveMaterial",
            categories: ["PCOTTIND001", "PCOTTIND002", "PCOTTGAS001", "PICOTTGAS002", "CUCINA001", "CUCINA002"],
            options: PianoCotturaMateriale
        },
        "Numero Fornelli": {
            source: "generalArticleDetails.stoveNumber",
            categories: ["PCOTTIND001", "PCOTTIND002", "PCOTTGAS001", "PICOTTGAS002"],
        },
        // CUCINA
        "Tipologia Piano Cottura Cucina": {
            label: "Tipologia Piano Cottura",
            source: "generalArticleDetails.cookerHobType",
            categories: ["CUCINA001", "CUCINA002"],
            options: CucinaTipologiaPianoCottura
        },
        // MICROONDE
        "Potenza Microonde (W)": {
            label: "Potenza Microonde (W)",
            source: "generalArticleDetails.microwavePower",
            categories: ["MICROONDE001", "MICROONDE002"]
        },
        "Volume Microonde (L)": {
            label: "Volume Microonde (L)",
            source: "generalArticleDetails.microwaveVolume",
            categories: ["MICROONDE001", "MICROONDE002"]
        },
        "Funzione Grill Microonde": {
            label: "Funzione Grill",
            source: "generalArticleDetails.microwaveGrillFunction",
            categories: ["MICROONDE001", "MICROONDE002"],
            options: SiNo
        },
        // CAPPE
        "Tipologia Cappe": {
            source: "generalArticleDetails.hoodType",
            categories: ["CAPPE001", "CAPPE002"],
            options: CappeTipologia
        },
        // LAVELLO
        "Tipologia Lavello": {
            source: "generalArticleDetails.sinkType",
            categories: ["LAVELLI001", "LAVELLI002"],
            options: LavelloTipologia
        },
        // MICROONDE
        "Posizionamento Microonde": {
            label: "Posizionamento",
            formLabel: "Posizionamento Elettrodomestico",
            source: "generalArticleDetails.appliancePositioning",
            categories: ["MICROONDE001", "MICROONDE002"],
            options: MicroondePosizionamento
        },
        "Volume Forno": {
            label: "Volume Forno (L)",
            formLabel: "Volume Forno",
            source: "generalArticleDetails.ovenVolume",
            categories: ["FORNI001", "FORNI002", "MICROONDE001", "MICROONDE002"]
        },
        "Consumo Energetico Modalita Convenzionale": {
            label: "Consumo Energetico Modalità Convenzionale (kWh)",
            formLabel: "Consumo Energetico Modalità Convenzionale",
            source: "generalArticleDetails.ovenEnergyConsumptionConventionalMode",
            categories: ["FORNI001", "FORNI002", "CUCINA001", "CUCINA002"]
        },
        "Consumo Energetico Modalita Ventilata": {
            label: "Consumo Energetico Modalità Ventilata (kWh)",
            formLabel: "Consumo Energetico Modalità Ventilata",
            source: "generalArticleDetails.ovenEnergyConsumptionFanMode",
            categories: ["FORNI001", "FORNI002"]
        },
        "Modalita Forno": {
            label: "Modalità Forno",
            formLabel: "Modalità Forno",
            source: "generalArticleDetails.ovenModes",
            categories: ["FORNI001", "FORNI002"]
        },
        "Tipologia Condizionatore": {
            source: "generalArticleDetails.airConditionerType",
            categories: ["CONDIZIONAT001", "CONDIZIONAT002"],
            options: CondizionatoreTipologia
        },
        "Copertura Ambiente Condizionatore": {
            label: "Copertura Ambiente (m²)",
            formLabel: "Copertura Ambiente Condizionatore",
            source: "generalArticleDetails.airConditionerEnvironmentCoverage",
            categories: ["CONDIZIONAT001", "CONDIZIONAT002"]
        },
        "Liquido Refrigerante Condizionatore": {
            label: "Liquido Refrigerante",
            formLabel: "Liquido Refrigerante Condizionatore",
            source: "generalArticleDetails.airConditionerRefrigerantLiquid",
            categories: ["CONDIZIONAT001", "CONDIZIONAT002"]
        }



    }

/**
 * Returns the attributes related to the marketplace.
 */
export const marketplaceAttributes: { [attribute: string]: ArticleAttribute } =
     {
        "MARKETPLACE - FLAG Mediaworld": {
            source: "mediaworldDetails.enabled",
            options: ["SI", "NO"],
            checkbox: true,
            label: "Mediaworld",
            formLabel: "MARKETPLACE - FLAG Mediaworld"
        },
         "MARKETPLACE - FLAG Leroy Merlin": {
             source: "leroyMerlinDetails.enabled",
             options: ["SI", "NO"],
             checkbox: true,
             label: "Leroy Merlin",
             formLabel: "MARKETPLACE - FLAG Leroy Merlin"
         },
         "MARKETPLACE - FLAG Ebay": {
             source: "ebayDetails.enabled",
             options: ["SI", "NO"],
             checkbox: true,
             label: "Ebay",
             formLabel: "MARKETPLACE - FLAG Ebay"
         },
         "MARKETPLACE - FLAG Kelkoo": {
             source: "kelkooDetails.enabled",
             options: ["SI", "NO"],
             checkbox: true,
             label: "Kelkoo",
             formLabel: "MARKETPLACE - FLAG Kelkoo"
         },
         "MARKETPLACE - FLAG ePrice": {
             source: "epriceDetails.enabled",
             options: ["SI", "NO"],
             checkbox: true,
             label: "ePrice",
             formLabel: "MARKETPLACE - FLAG ePrice"
         }
    }



export const articleAttributes: { [attribute: string]: ArticleAttribute } =
    {
        "TItolo Articolo ITA": {
            source: "headerArticleDetails.title",
        },
        "codice": {
            source: "headerArticleDetails.code"
        },
        "unitaInStock": {
            source: "headerArticleDetails.availability"
        },
        "categoriaMerceologica": {
            source: "headerArticleDetails.category"
        },
        "codiceAlternativo": {
            source: "headerArticleDetails.ean"
        },
        "imgProdotto": {
            source: "headerArticleDetails.imageLink"
        },
        "Marca": {
            source: "generalArticleDetails.brand",
            options: brands,
            // transform: (str) => str.toUpperCase()
        },
        "Classe Energetica": {
            source: "generalArticleDetails.energyClass",
            options: energyClass
        },
        "Scala Energetica": {
            source: "generalArticleDetails.energyScale",
            options: energyScale,
        },
        "Altezza": {
            source: "generalArticleDetails.dimensions.height"
        },
        "Larghezza": {
            source: "generalArticleDetails.dimensions.length"
        },
        "Profondità": {
            source: "generalArticleDetails.dimensions.width"
        },
        "Colore": {
            source: "generalArticleDetails.color",
            options: colors,
        },
        "Rumorosità": {
            source: "generalArticleDetails.noisiness"
        },
        "descrizioneHtml": {
            source: "description"
        },
        "Scheda Tecnica": {
            source: "technicalDetails"
        },
        "PDF Classe Energetica": {
            source: "generalArticleDetails.euEnergyLabelExternalUrl"
        },
        "PDF Scheda Prodotto": {
            source: "generalArticleDetails.euProductFicheExternalUrl"
        },
        ...specificCategoryArticleAttributes,
        ...marketplaceAttributes
        // "FRASE - Istruzioni non disponibili":,
        // "FRASE - Imballo Rovinato",
        // "FRASE - Prodotto Testato",
        // "FRASE - Altri dettagli",
        // "FRASE - Tempo Evasione Ordine",
        // "FRASE MANUALE - Altri dettagli",
        // "FRASE - Garanzia 24 Mesi Ufficiale Italia",
        // "FRASE - Prodotto Mai Usato",
    }


const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

export type CompareTabKey = "articleInfo" | "technicalDetails" | "description" | "otherDetails";

export interface CompareTabConfig {
    key: CompareTabKey;
    label: string;
    icon: string;
}

export const COMPARE_TAB_CONFIGS: CompareTabConfig[] = [
    { key: "articleInfo", label: "Info Articolo", icon: "info" },
    { key: "technicalDetails", label: "Scheda Tecnica", icon: "find_in_page" },
    { key: "description", label: "Descrizione", icon: "description" },
    { key: "otherDetails", label: "Altri Dettagli", icon: "quick_reference" },
];

/**
 * Categorizes article attributes into tabs for comparison.
 * Logic mirrors how tabs render fields in ModalArticle:
 * - articleInfo: general fields + category-specific fields (non-checkbox)
 * - technicalDetails: only "Scheda Tecnica"
 * - description: only "descrizioneHtml"
 * - otherDetails: checkbox fields (marketplace flags)
 * 
 * @param category - the article's category code to filter category-specific fields
 * @returns Record mapping tab keys to arrays of attribute keys (formLabel or attr name)
 */
export const getAttributesByTab = (category: string): Record<CompareTabKey, string[]> => {
    const result: Record<CompareTabKey, string[]> = {
        articleInfo: [],
        technicalDetails: [],
        description: [],
        otherDetails: [],
    };

    for (const [attr, details] of Object.entries(articleAttributes)) {
        const formLabel = details.formLabel || attr;
        
        // Special cases for specific tabs
        if (attr === "Scheda Tecnica") {
            result.technicalDetails.push(formLabel);
            continue;
        }
        
        if (attr === "descrizioneHtml") {
            result.description.push(formLabel);
            continue;
        }
        
        // Checkbox fields go to otherDetails (marketplace flags)
        if (details.checkbox) {
            result.otherDetails.push(formLabel);
            continue;
        }
        
        // Skip header fields (not editable in form)
        if (details.source.startsWith("headerArticleDetails.")) {
            continue;
        }
        
        // Category-specific fields: only include if matches category
        if (details.categories) {
            if (details.categories.includes(category)) {
                result.articleInfo.push(formLabel);
            }
            continue;
        }
        
        // General fields (no categories restriction) go to articleInfo
        result.articleInfo.push(formLabel);
    }

    return result;
}

/**
 * This function sets a value on an object given the path position
 * @param obj the object to populate
 * @param path the path of the object to set the value to
 * @param value the value to set
 */
export const setNestedValue = (obj: any, path: string, value: any) => {
    const keys = path.split('.');
    const lastKey = keys.pop()!;  // Get the last key, which is where the value will be set

    const target = keys.reduce((acc, key) => {
        // Create an empty object if the key doesn't exist
        if (acc[key] === undefined) {
            acc[key] = {};
        }
        return acc[key];
    }, obj);

    target[lastKey] = value;  // Set the value at the final key
};

/**
 * Get the list of attributes that are specific for a given article.
 * The Article Object contains all possible attributes for all possible categories.
 * This functions returns only the attributes that are specific for a given article
 * @param article
 */
export const mapArticleAttributes = (article: ArticleDetails) => {
    let filteredArticleAttributes: { [attribute: string]: any } = {}

    for (const [attr, details] of Object.entries(articleAttributes)) {
        if (!details.categories || details.categories.includes(article.headerArticleDetails.category)) {
            // If the attribute belongs to the category
            const value = getNestedValue(article, details.source)
            const formLabel = ('formLabel' in details && details['formLabel']) ? details['formLabel'] : attr;
            filteredArticleAttributes[formLabel] = value
        }
    }

    // console.log("FILTERED ATTRIBUTES")
    // console.log(filteredArticleAttributes)

    return filteredArticleAttributes;
}

